import "./SuccessPopup.css";

interface SuccessPopupProps {
    open: boolean;
    onClose: () => void;
    /** When set, shows this text instead of the default success title + image (e.g. duplicate ticket notice). */
    infoMessage?: string;
}

export default function SuccessPopup({ open, onClose, infoMessage }: SuccessPopupProps) {
    if (!open) return null;
    if (infoMessage) {
        return (
            <div className="success-popup-overlay">
                <div className="success-popup">
                    <div className="success-popup-text success-popup-info-body">{infoMessage}</div>
                    <button type="button" className="success-popup-close" onClick={onClose}>
                        סיום
                    </button>
                </div>
            </div>
        );
    }
    return (
        <div className="success-popup-overlay">
            <div className="success-popup">
                <div className="success-popup-title">פנייתכם התקבלה בהצלחה</div>
                <img
                    src={require("../../assets/state_completed.png")}
                    alt="הושלם"
                    className="success-popup-image"
                />
                <button type="button" className="success-popup-close" onClick={onClose}>
                    סיום
                </button>
            </div>
        </div>
    );
}
